import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Table/sgds-table-head";
import { register } from "../../utils/ce-registry";

register("sgds-table-head", Component);

export default createComponent({
  react: React,
  tagName: "sgds-table-head",
  elementClass: Component,
  events: {}
});
